import logrocket from '@/services/logrocket';

import {
  fetchByType as fetchByTypeApi,
  fetchByCode as fetchByCodeApi,
  create as createApi,
  update as updateApi,
  remove as removeApi
} from 'services/api/widget';

export const fetchByType = async (page, type) => {
  try {
    const { data } = await fetchByTypeApi(page, type);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const fetchByCode = async (code) => {
  try {
    const { data } = await fetchByCodeApi(code);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const create = async (payload) => {
  try {
    const { data } = await createApi(payload);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const update = async (payload) => {
  try {
    const { data } = await updateApi(payload);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const remove = async (payload) => {
  try {
    await removeApi(payload);
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};
